import type { Amplify } from 'aws-amplify';

const getAuthConfigAws = (): ReturnType<typeof Amplify.getConfig>['Auth'] => {
  return {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USERPOOLID,
      userPoolClientId: import.meta.env.VITE_AWS_USERPOOL_WEB_CLIENT_ID,
      loginWith: {
        email: true,
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          redirectSignIn: [import.meta.env.VITE_OAUTH_REDIRECT_SIGNIN],
          redirectSignOut: [import.meta.env.VITE_OAUTH_REDIRECT_SIGNOUT],
          responseType: 'code',
          scopes: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
          providers: ['Google'],
        },
      },
    },
  };
};

export { getAuthConfigAws };
